// Import React's useEffect for side effects and useLocation to access the current route
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


// This component scrolls the window to the top or to a specific element when the route changes.
function ScrollToTop() {
  // Get the current pathname and hash from the URL
  const { pathname, hash } = useLocation();


  useEffect(() => {
    // If there is no hash in the URL, scroll to the top of the page
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // If there is a hash, try to scroll smoothly to the element with the corresponding id
    const targetId = hash.replace("#", "");
    const target = document.getElementById(targetId);

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathname, hash]);

  // This component does not render anything in the DOM
  return null;
}

// Export the ScrollToTop component for use in the app
export default ScrollToTop;
